
    <portal-create-account-form
      [text]="authText$ | async"
      [completingPassword]="isCompletingPassword$ | async"
      [cognitoUser]="cognitoUser$ | async"
      [error]="createAccountError$ | async"
      (createCoreAccount)="handleAccountSubmission($event)"
    >
    </portal-create-account-form>
  